import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import { useAPI } from 'src/util/use-api';
import { QUERIES } from 'src/util/globals';

type UseUserGroupsParams = {
  enabled?: boolean;
  searchQuery?: string;
};

export const useUserGroups = ({
  enabled = false,
  searchQuery,
}: UseUserGroupsParams) => {
  const { API } = useAPI();

  return useInfiniteQuery({
    queryKey: [QUERIES.GROUPS, searchQuery],

    queryFn: async ({ pageParam }) => {
      return (
        await API?.profilesAPI.profilesProfileUserGroupsList({
          nextKey: pageParam || undefined,
          query: searchQuery,
        })
      )?.data;
    },

    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage?.next_key || undefined,
    enabled,
    placeholderData: keepPreviousData,
  });
};
